import fileMedia from './file-media'
export default fileMedia
